import { render, staticRenderFns } from "./ProductInstruction.vue?vue&type=template&id=2d20dbac&scoped=true"
import script from "./ProductInstruction.vue?vue&type=script&lang=js"
export * from "./ProductInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20dbac",
  null
  
)

export default component.exports